"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _react = _interopRequireWildcard(require("react"));
var _textarea = _interopRequireDefault(require("@amzn/meridian/textarea"));
var _text = _interopRequireDefault(require("@amzn/meridian/text"));
var _column = _interopRequireDefault(require("@amzn/meridian/column"));
var _row = _interopRequireDefault(require("@amzn/meridian/row"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _cg = require("react-icons/cg");
var _useResponse2 = _interopRequireDefault(require("../hooks/useResponse"));
var _FeedbackConstants = require("../constants/FeedbackConstants");
var _colorStyles = _interopRequireDefault(require("../enums/colorStyles"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
/**
 * TextQuestion component will be used to get users suggestions.
 * @param {string} question - Question text
 * @param {number} [limit = 60] - Maximum number of words a user can enter
 * @param {string} [label = ""]
 * @param {string} [placeholder = "Enter your valuable suggestions"]
 * @param {number} [rows = 4] - Used to define width of Textarea
 * @returns Meridian Textarea Component
 */

var TextQuestion = function TextQuestion(_ref) {
  var question = _ref.question,
    id = _ref.id,
    isMandatory = _ref.isMandatory,
    limit = _ref.limit,
    label = _ref.label,
    placeholder = _ref.placeholder,
    rows = _ref.rows,
    prePopulatedValue = _ref.prePopulatedValue;
  var _useState = (0, _react.useState)(''),
    _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
    content = _useState2[0],
    setContent = _useState2[1];
  var _useState3 = (0, _react.useState)(0),
    _useState4 = (0, _slicedToArray2["default"])(_useState3, 2),
    charCount = _useState4[0],
    setCharCount = _useState4[1];
  var _useResponse = (0, _useResponse2["default"])(),
    saveFeedbackResponse = _useResponse.saveFeedbackResponse,
    answers = _useResponse.response.answers;
  var limitCharacters = function limitCharacters(text) {
    var response;
    var trimmedText = text === null || text === void 0 ? void 0 : text.trim();
    if (trimmedText.length === 0) {
      response = '';
      setContent(trimmedText);
    } else if ((trimmedText === null || trimmedText === void 0 ? void 0 : trimmedText.length) > limit) {
      var updatedText = trimmedText.slice(0, limit);
      setContent(updatedText);
      setCharCount(limit);
      response = updatedText;
    } else {
      setContent(text);
      setCharCount(trimmedText.length);
      response = trimmedText;
    }
    saveFeedbackResponse({
      id: id,
      answer: response
    });
  };
  (0, _react.useEffect)(function () {
    if (prePopulatedValue) {
      limitCharacters(prePopulatedValue);
    }
  }, [prePopulatedValue, answers.length]);
  return /*#__PURE__*/_react["default"].createElement(_column["default"], {
    spacingInset: "xxsmall"
  }, /*#__PURE__*/_react["default"].createElement(_text["default"], null, question, ' ', isMandatory && /*#__PURE__*/_react["default"].createElement(_cg.CgAsterisk, {
    "aria-label": "required",
    color: _colorStyles["default"].REQUIRED
  })), /*#__PURE__*/_react["default"].createElement(_textarea["default"], {
    rows: rows,
    value: content,
    onChange: function onChange(value) {
      return limitCharacters(value);
    },
    placeholder: placeholder,
    label: label,
    disabled: Boolean(prePopulatedValue)
  }), /*#__PURE__*/_react["default"].createElement(_row["default"], {
    alignmentHorizontal: "right",
    widths: "fit"
  }, /*#__PURE__*/_react["default"].createElement(_text["default"], null, charCount, "/", limit)));
};
TextQuestion.propTypes = {
  question: _propTypes["default"].string.isRequired,
  id: _propTypes["default"].string.isRequired,
  isMandatory: _propTypes["default"].bool.isRequired,
  limit: _propTypes["default"].number,
  label: _propTypes["default"].string,
  placeholder: _propTypes["default"].string,
  rows: _propTypes["default"].number,
  prePopulatedValue: _propTypes["default"].string
};
TextQuestion.defaultProps = {
  limit: 60,
  label: '',
  placeholder: _FeedbackConstants.PLACEHOLDERS.textQuestion,
  rows: 4,
  prePopulatedValue: ''
};
var _default = exports["default"] = TextQuestion;
//# sourceMappingURL=TextQuestion.js.map